export default __webpack_public_path__ + "tmp_src/components/LightDarkToggle/LightDarkToggle.css.liquid";